<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <div class="card">
      <div class="card-body w-100 pb-0">
        <div [ngClass.xl]="'float-left'" [ngClass.md]="'float-left'" [ngClass.sm]="'mb-075'">
          <input type="search" id="datatable-search-input" [placeholder]="'SEARCH' | translate" class="form-control" (change)="filterRefunds()" [(ngModel)]="searchKeyword" />
        </div>
        <div [ngClass.xl]="'float-left ml-1'" [ngClass.md]="'float-left ml-1'">
          <select [(ngModel)]="searchStatus" class="form-control" (change)="filterRefunds()">
            <option value="3" selected>{{ "ALL_FEMALE_PLURAL" | translate }}</option>
            <option value="0">{{ "PENDING" | translate }}</option>
            <option value="1">{{ "APPROVED_FEMALE_PLURAL" | translate }}</option>
            <option value="2">{{ "NOT_APPROVED_PLURAL" | translate }}</option>
          </select>
        </div>
        <label for="monthYear" class="mb-0 ml-1">
          <select [(ngModel)]="selectedMonth" (ngModelChange)="filterRefunds()" id="monthYear" class="form-control pr-3 text-capitalize">
            <option selected disabled>{{ "MONTH" | translate }}</option>
            <option [value]="0">{{ "ALL_MONTHS" | translate }}</option>
            <option *ngFor="let month of months; let i = index" [value]="i">{{ month }}</option>
          </select>
        </label>
        <label for="years" class="mb-0 ml-1">
          <select id="years" [(ngModel)]="selectedYear" (change)="filterRefunds()" class="form-control pr-3">
            <option *ngFor="let year of years" [value]="year">{{ year }}</option>
          </select>
        </label>
        <div class="float-right" [ngClass.sm]="'d-none'">
          <div class="d-inline-block">
            <app-select-table-limit [defaultValue]="tableLimit" (onChange)="tableLimit = $event"></app-select-table-limit>
          </div>
        </div>
        <div class="clearboth"></div>
      </div>
      <div class="card-body px-0 pb-0">
        <ngx-datatable
          class="bootstrap core-bootstrap"
          columnMode="force"
          [headerHeight]="30"
          [scrollbarH]="true"
          [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
          [rowHeight]="_utilService.isDesktop ? 50 : 180"
          [limit]="tableLimit"
          [footerHeight]="50"
          [rows]="filteredRefunds"
        >
          <ngx-datatable-column name="{{ 'FIRSTNAME' | translate }}" prop="employee.complete_name" width="100" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.employee.complete_name }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'AMOUNT' | translate }}" prop="amount" width="200" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.amount | currency: 'EUR' }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'DAY_CAPITALIZE' | translate }}" prop="date" width="100" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span class="line-height-1">{{ row.date.toString() | date: "dd/MM/YYYY" }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'STATE' | translate }}" prop="status" width="100" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span class="badge badge-success" *ngIf="row.status === 1">{{ row.enabled_label }}</span>
              <span class="badge badge-warning" *ngIf="row.status === 0">{{ row.enabled_label }}</span>
              <span class="badge badge-danger" *ngIf="row.status === 2">{{ row.enabled_label }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'ACTIONS' | translate }}" [sortable]="false" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="d-flex align-items-center">
                <button class="btn btn-outline-secondary btn-sm" (click)="openModal(viewRefund, row)">{{ "VIEW" | translate }}</button>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <!--mobile - tablet-->
          <ngx-datatable-column name="{{ 'FIRSTNAME' | translate }}" prop="employee.complete_name" width="100" [sortable]="true" *ngIf="!_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="row list-item-mobile">
                <div class="col-12">
                  <div class="d-flex align-items-center justify-content-between" ngClass.md="pr-1">
                    <span>{{ row.employee.complete_name }}</span>
                    <span class="badge badge-success" *ngIf="row.status === 1">{{ row.enabled_label }}</span>
                    <span class="badge badge-warning" *ngIf="row.status === 0">{{ row.enabled_label }}</span>
                    <span class="badge badge-danger" *ngIf="row.status === 2">{{ row.enabled_label }}</span>
                  </div>
                  <div class="my-1">
                    <span>{{ row.amount }} €</span>
                  </div>
                  <div class="d-flex align-items-center justify-content-between" ngClass.md="pr-1">
                    <span>{{ row.date.toString() | date: "dd/MM/YYYY" }}</span>
                    <button class="btn btn-outline-secondary" (click)="openModal(viewRefund, row)">{{ "VIEW" | translate }}</button>
                  </div>
                </div>
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
    </div>
  </div>
</div>

<!-- Modal Refund -->
<ng-template #viewRefund let-modal>
  <form>
    <div class="modal-header">
      <div></div>
      <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body" tabindex="0">
      <h3>{{ "REFUND" | translate }}</h3>
      <div class="row">
        <div class="col-6">
          <small class="text-muted mb-0 pb-0">{{ "FIRSTNAME" | translate }}:</small>
          <p>{{ currentRefund?.employee?.complete_name }}</p>
        </div>
        <div class="col-6">
          <small class="text-muted mb-0 pb-0">{{ "AMOUNT" | translate }}:</small>
          <p>{{ currentRefund.amount }} €</p>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <small class="text-muted mb-0 pb-0">{{ "DAY_CAPITALIZE" | translate }}:</small>
          <p>{{ _utilService.formatDate(currentRefund.date, "DD/MM/YY") }}</p>
        </div>
      </div>
      <div *ngIf="currentRefund.note" class="row">
        <div class="col-6">
          <small class="text-muted mb-0 pb-0">{{ "NOTE" | translate }}:</small>
          <p>{{ currentRefund.note }}</p>
        </div>
      </div>
      <div *ngIf="currentRefund.file_url" class="row">
        <div class="col-6">
          <small class="text-muted mb-0 pb-0">{{ "FILE" | translate }}:</small>
          <a class="d-block text-primary" (click)="openFile(currentRefund.file_url)">{{ "VIEW" | translate }} {{ "FILE" | translate }}</a>
        </div>
      </div>
      <div *ngIf="currentRefund.status_note" class="row">
        <div class="col-6">
          <small class="text-muted mb-0 pb-0">{{ "MOTIVATION" | translate }}:</small>
          <p>{{ currentRefund.status_note }}</p>
        </div>
      </div>
    </div>
    <div *ngIf="currentRefund.status < 2 && _authenticationService.hasCapability('manage_refund_request') && currentRefund.user_hash !== me.hash" class="modal-footer d-flex justify-content-center">
      <button
        *ngIf="currentRefund.user_hash !== me.hash && (currentRefund.status === 0 || currentRefund.status === 1)"
        (click)="toggleEnabled(currentRefund, 'reject'); modal.close()"
        type="button"
        class="btn btn-outline-danger w-150"
        rippleEffect
      >
        {{ "REJECT" | translate }}
      </button>
      <button *ngIf="currentRefund.user_hash !== me.hash && currentRefund.status === 0" (click)="toggleEnabled(currentRefund, 'approve'); modal.close()" type="button" class="btn btn-outline-success w-150" rippleEffect>
        {{ "APPROVE" | translate }}
      </button>
    </div>
  </form>
</ng-template>
<!-- / Modal Refund -->

<!-- Modal Reject Refund -->
<ng-template #rejectRefundModal let-modal>
  <div>
    <div class="modal-header">
      <div></div>
    </div>
    <div class="modal-body" tabindex="0">
      <h3>{{ "INSERT_MOTIVATION_NOTE" | translate }}</h3>
      <div>
        <label for="rejectNote">{{ "MOTIVATION" | translate }}<sup class="text-danger">*</sup></label>
        <textarea [(ngModel)]="rejectedNote" class="form-control" name="rejectNote" id="rejectNote" cols="45" rows="3"></textarea>
      </div>
    </div>
    <div class="modal-footer d-flex justify-content-center">
      <button [disabled]="rejectedNote.length === 0" type="submit" (click)="rejectRefund(currentRefund)" class="btn btn-primary w-150" rippleEffect *ngIf="_authenticationService.hasCapability('manage_refund_request')">
        {{ "SEND" | translate }}
      </button>
    </div>
  </div>
</ng-template>
<!-- / Modal Reject Refund -->
